import {
  SlProgressBar
} from "./chunk.KZZ2Q4B6.js";

// src/components/progress-bar/progress-bar.ts
var progress_bar_default = SlProgressBar;
SlProgressBar.define("sl-progress-bar");

export {
  progress_bar_default
};
